import { render, staticRenderFns } from "./index.vue?vue&type=template&id=da38527a&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=da38527a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da38527a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da38527a')) {
      api.createRecord('da38527a', component.options)
    } else {
      api.reload('da38527a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=da38527a&scoped=true&", function () {
      api.rerender('da38527a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/comment/components/comment-item/index.vue"
export default component.exports